import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, MARKS } from "@contentful/rich-text-types";
import axios from 'axios';
import { LoadingGif } from "/src/Components/LoadingGif/LoadingGif";
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';
import { WindowSizeContext, TestStatusContext, AddressSearchContext } from '/src/App';
import ResourceCard from '/src/Components/ResourceCard/ResourceCard';


// import { ProjectCardResources } from "/src/modules/ProjectCardResources/ProjectCardResources";
// import { fetchContent } from "/src/services/GetContent";
// import Skeleton from '@mui/material/Skeleton';
// import { LoadingGif } from "/src/components/LoadingGif";
// import { ContentFooter } from "/src/components/ContentFooter";
// import { UserStatus } from "/src/services/UserMgt";
import "./style.css";

// During testing
import data from './sample_blog.json'

export const Blog = () => {

  const { portalData } = useContext(AddressSearchContext);


  // Get the setPageTitle property from userStatus
  // const { setPageTitle } = useContext(UserStatus);

  // Navigator if error
  const navigate = useNavigate();

  // Get the slug from the URL
  const slug = useParams().slug

  // Is Privacy in the URL (not just the slug)?
  const isPrivacy = window.location.pathname.includes('/privacy/');


  const [newTitle, setNewTitle] = useState(null)

  // useEffect(() => {

  //   if (newTitle) {

  //     document.title = newTitle;
  //     setPageTitle(newTitle);
  //   }
  //   // This will run when the page first loads and whenever the title changes
  // }, [newTitle]);

  // Set up the blog and blog status states
  const [blog, setBlog] = useState(null)
  const [blogTitle, setBlogTitle] = useState(null)
  const [blogDescription, setBlogDescription] = useState(null)
  const [blogTruncatedDescription, setBlogTruncatedDescription] = useState(null)
  const [blogStatus, setBlogStatus] = useState(false)
  const [blogTimestamp, setBlogTimestamp] = useState(null)
  const [blogRelatedResources, setBlogRelatedResources] = useState(null)

  // useEffect that monitors blog and when blog exists, blog.article.title and setNewTitle
  useEffect(() => {

    if (blog) {
      console.log(blog);

      if (blog.article && blog.article.title) {
        // document.title = blog.article.title;
        setBlogTitle(blog.article.title + " | Quoll")
      }

      // Set the blog description and truncated description for SEO
      if (blog.article && blog.article.body) {
        const blogBlurb = blog.article.body?.content?.find(
          item => item.nodeType === "paragraph"
        )?.content?.[0]?.value || null
        setBlogDescription(blogBlurb)
        setBlogTruncatedDescription(blogBlurb ? blogBlurb.substring(0, 150) + "..." : null)
      }
      // Set the blog timestamp
      if (blog.article) {

        const createdAt = blog.article.createdAt;
        const updatedAt = blog.article.updatedAt;

        const createdAtDate = new Date(createdAt);
        const updatedAtDate = new Date(updatedAt);

        const createdAtDateString = createdAtDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        const updatedAtDateString = updatedAtDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

        if (updatedAt) {
          setBlogTimestamp(updatedAtDateString)
        } else if (createdAt) {
          setBlogTimestamp(createdAtDateString)
        } else {
          // Set to todays date
          const today = new Date();
          const todayDateString = today.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
          setBlogTimestamp(todayDateString)
        }
      }
      if (blog.article && blog.related_resources) {
        const relatedResourcesList = blog.related_resources || [];
        if (relatedResourcesList.length > 0) {
          setBlogRelatedResources(relatedResourcesList);
        }
      }
    }



  }, [blog]);

  // // Call the Quoll API to get the content
  useEffect(() => {
    const fetchBlogContent = async () => {
      try {
        const request_param = { slug: slug };

        // Make the API call
        const response = await axios.post(
          `${import.meta.env.VITE_BLOG_BASE_URL}`,
          request_param
        );

        if (response.data.status === 'success') {
          setBlog(response.data);
          // setNewTitle(response.data.article.title);
          setBlogStatus(true);
          // Scroll to top after successful data load
          window.scrollTo(0, 0);
        } else {
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Failed to fetch blog content:', error);
        navigate('/', { replace: true });
      }
    };

    fetchBlogContent();
  }, [slug, navigate]);



  const blogContent = blog?.article
  const relatedContent = blogContent?.related_resources

  const blog_image = blogContent ? CreateCloudfrontUrl(blogContent.image) : null;
  const blog_content = blogContent ? blogContent.body : null;
  // const blog_tags = blogContent ? blogContent.associated_house_categories.concat(blogContent.associated_climate_risks) : [];
  const isThereAnImage = blogContent ? blogContent.image : null;

  const ITALIC = ({ children }) => <p className={"italic"}>{children}</p>;

  const RICHTEXT_OPTIONS = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        return <p className={"blog-paragraph"}>{children}</p>
      },
      [BLOCKS.HEADING_2]: (node, children) => {
        return <h2 className={"blog-h2"}>{children}</h2>
      },
      [BLOCKS.HEADING_3]: (node, children) => {
        return <h3 className={"blog-h3"}>{children}</h3>
      },
      // [BLOCKS.UL_LIST]: (node, children) => {
      //   return <li className={"blog-li"}>{children}</li>
      // },
      [BLOCKS.UL_LIST]: (node, children) => {
        return <ul className={"blog-ol"}>{children}</ul>
      },
      [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
        return <img className={"blog-inline-image"} src={node.data} />
      },
    },
    renderMark: {

      [MARKS.BOLD]: text => <b>{text}</b>,
      [MARKS.ITALIC]: text => <i className={"italic"}>{text}</i>
    }
  }

  // Used for testing that the loading gif is showing correctly
  // const tester = true;

  return (
    <>
      <HelmetProvider
        pageType="blog"
        customTitle={blogTitle}
        customDescription={blogTruncatedDescription}
      />
      <div className={`blog-frame ready-${blogStatus}`}>

        {/* <h1>Blog</h1>
      <h2>{slug}</h2> */}
        {/* {(!blog) && <LoadingGif />} */}
        {/* <LoadingGif /> */}
        {!blog && <LoadingGif />}
        {blog && (
          <>
            <div className="blog-article">
              <div className={`blog-hero ${isThereAnImage ? '' : 'blog-hero-no-image'}`}>
                {isThereAnImage && (
                  <img
                    src={blog_image}
                    alt={blogContent && blogContent.title}
                    className="blog-hero-image"
                  />
                )}
                <div className={`blog-hero-overlay ${isThereAnImage ? '' : 'blog-hero-no-image-overlay'}`}></div>
                <h1 className="blog-hero-title text-align-center">
                  {blogTitle}
                </h1>
              </div>

              {!isPrivacy && (
                <>
                  <div className="blog-description text-align-center">
                    <div className="blog-description-left-vertical-line"></div>
                    {blogDescription &&
                      <p dangerouslySetInnerHTML={{ __html: blogDescription }} />
                    }
                  </div>

                  <div className="blog-meta">
                    <div className="blog-share">
                      <span className="share-label">SHARE THIS POST:</span>
                      <div className="share-icons">
                        <a href="#" className="share-icon"><i className="fab fa-linkedin-in"></i></a>
                        <a href="#" className="share-icon"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="share-icon"><i className="fab fa-facebook-f"></i></a>
                      </div>
                    </div>

                    <div className="blog-attribution">
                      <span className="blog-date">{blogTimestamp}</span>
                      <span className="blog-author">Quoll</span>
                    </div>
                  </div>
                </>

              )}

            </div>
            <div className="blog-content-wrapper">

              <div className="blog-frame">

                {documentToReactComponents(blog_content, RICHTEXT_OPTIONS)}
                {blogRelatedResources &&
                  <div className="blog-related-resources-container">
                    <h2>Related Resources</h2>
                    <div className="blog-related-resources">
                      {blogRelatedResources.map((resource, index) => (
                        <ResourceCard key={index} resource={resource} />
                      ))}
                    </div>
                    {/* ))} */}
                    {/* {relatedContent ? <ProjectCardResources resources={relatedContent} style="dark" /> : <Skeleton variant="rectangular" />} */}
                  </div>
                }
              </div>
              {/* <ContentFooter /> */}
            </div>
          </>
        )}
      </div>
    </>
  );
};
